<script>
  import { tick, createEventDispatcher } from 'svelte';
  import { notifications } from './notification/notifications';
  import { fetchConfig, postConfig, fetchConfigHistory } from '../api';
  import CodeEditor from './CodeEditor.svelte';
  import Select from 'svelte-select';

  export let data;

  const dispatch = createEventDispatcher();

  let currentType = 'frontend';
  let text;
  let historyCheck = 0;

  const switchConfig = (type) => {
    currentType = type;
  };
  const fetchConfigByType = async (name = null) => {
    await tick();
    text = JSON.stringify(await fetchConfig(currentType, data.cid, name), null, 2);
    runHistory = fetchConfigHistory(currentType, data.cid);
    historyCheck++;
  };
  const saveConfig = async (e) => {
    await postConfig(currentType, data.cid, e.detail);
    notifications.success(`Config for ${data.label} saved!`, 800);
  };

  const update = async (e, key) => {
    console.log('update');
    let jsonText = JSON.parse(text);
    if (jsonText[key]) {
      if (JSON.stringify(jsonText[key].code, null, 2) != JSON.stringify(e.detail, null, 2)) {
        jsonText[key].code = e.detail;
        text = JSON.stringify(jsonText, null, 2);
      }
    }
  };
  const selectConfigVersion = async (e) => {
    notifications.warning(`Loaded  ${e.detail.name} config from history!`, 2000);
    return fetchConfigByType(e.detail.name);
  };
  let runHistory = fetchConfigHistory(currentType, data.cid);
  const optionIdentifier = 'name';
  const labelIdentifier = 'name';

  $: if (currentType) {
    console.log('fetchConfigType');
    fetchConfigByType();
  }
</script>

<svelte:head>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/jshint/2.13.4/jshint.min.js"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/jsonlint/1.6.0/jsonlint.min.js"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/csslint/1.0.5/csslint.min.js"></script>
</svelte:head>
<h2>
  <button on:click={() => dispatch('back')}
    ><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="svelte-1bbht2t"
      ><path
        d="M9 17L1 9L9 1"
        stroke="#091EB5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="svelte-1bbht2t"
      /></svg
    ></button
  >
  Editing - <span>{data.client_name + ' , ' + data.cid}</span>
</h2>
<nav>
  <button class:active={currentType == 'app-configs'} on:click={() => switchConfig('app-configs')}>App Config</button>
  <button class:active={currentType == 'backend'} on:click={() => switchConfig('backend')}>Back End</button>
  <button class:active={currentType == 'frontend'} on:click={() => switchConfig('frontend')}> Front End</button>
  <button class:active={currentType == 'modelling'} on:click={() => switchConfig('modelling')}>Modelling</button>
  <button class:active={currentType == 'reporting'} on:click={() => switchConfig('reporting')}>Reporting</button>
</nav>
<div style="min-height:60px">
  {#await runHistory then history}
    {#if Array.isArray(history)}
      <Select items={history.reverse()} {labelIdentifier} {optionIdentifier} on:select={selectConfigVersion} placeholder={'View History'} />
    {:else}
      <p>No configs found</p>
    {/if}
  {/await}
</div>
{#await selectConfigVersion then value}
  {#await value then val}
    {#if val}
      <!-- content here -->
      <div style="min-height:600px">
        {#if text != null}
          <CodeEditor {historyCheck} {text} configType={currentType} on:save={saveConfig} />
        {/if}
        {#if currentType == 'frontend' && text != null && JSON.parse(text).embedstyles}
          <CodeEditor
            lang="css"
            text={JSON.parse(text).embedstyles.code}
            saveDisabled={true}
            configType={currentType}
            {historyCheck}
            on:update={(e) => update(e, 'embedstyles')}
          />
        {/if}
        {#if currentType == 'frontend' && text != null && JSON.parse(text).locale}
          <CodeEditor
            text={JSON.parse(text).locale.code}
            saveDisabled={true}
            configType={currentType}
            {historyCheck}
            on:update={(e) => update(e, 'locale')}
          />
        {/if}
      </div>
    {/if}
  {/await}
{/await}

<style>nav{padding:.5em 0}span{color:var(--s-c)}nav button{border-left:1px solid #ddd;font-size:1em;padding:1em 2em}nav button:last-of-type{border-right:1px solid #ddd}nav button.active{background-color:#ddd}</style>
